import { render, staticRenderFns } from "./SaveEnvironmentModal.vue?vue&type=template&id=2bcb8fd7&"
import script from "./SaveEnvironmentModal.vue?vue&type=script&lang=ts&"
export * from "./SaveEnvironmentModal.vue?vue&type=script&lang=ts&"
import style0 from "./SaveEnvironmentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports